import { tokensRx } from '../utils/utils';
import { isValidDate } from '../default-exports';
function splitToTokens(template, formatters) {
    var RX_TOKENS = tokensRx(formatters);
    var tokens = template.match(RX_TOKENS);
    // this regexp cant fail because of "|."
    var result = [];
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        var tokenFn = formatters[token];
        if (tokenFn) {
            result.push(tokenFn);
        }
        else if (token.charAt(0) === '[' && token.charAt(token.length - 1) === ']') {
            result.push(token.substring(1, token.length - 1));
        }
        else {
            result.push(token);
        }
    }
    return result;
}
function formatByTokens(d, tokens) {
    var result = [];
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        result.push(typeof token === 'function' ? token(d, i, tokens) : token);
    }
    return result.join('');
}
export function createFormat(formatters) {
    var cache = {};
    return function (d, template) {
        if (!isValidDate(d))
            return null;
        var tokens = cache[template];
        if (tokens === undefined) {
            tokens = splitToTokens(template, formatters);
            cache[template] = tokens;
        }
        return formatByTokens(d, tokens);
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-date/esm/src/format/create-format.js
// module id = null
// module chunks = 